<template>
  <div :class="size == 'small' ? 'price small' : 'price'">
    <div>
      <img
        :src="unionInfo.icon ? unionInfo.icon : fudou"
        alt=""
        class="fudou"
      />
      <span :class="type == 'big' ? 'priceBig white' : 'priceBig'"
        >{{ dealPrice[0] }}.</span
      >
      <span :class="type == 'big' ? 'priceSmall white' : 'priceSmall'">{{
        dealPrice[1]
      }}</span>
      <span
        :class="type == 'big' ? 'grey start' : 'start'"
        v-if="onlyOnePrice == 0 && (!highPrice || highPrice === 'null')"
        >{{TLang('起','home')}}</span
      >
      <span
        :class="type == 'big' ? 'priceSmall white' : 'priceBig'"
        v-if="onlyOnePrice == 0 && highPrice && highPrice !== 'null'"
        >~</span
      >
      <img
        :src="unionInfo.icon ? unionInfo.icon : fudou"
        alt=""
        class="fudou"
        v-if="onlyOnePrice == 0 && highPrice && highPrice !== 'null'"
      />
      <span
        v-if="onlyOnePrice == 0 && highPrice && highPrice !== 'null'"
        :class="type == 'big' ? 'priceBig white' : 'priceBig'"
        >{{ dealHighPrice[0] }}.</span
      >
      <span
        v-if="onlyOnePrice == 0 && highPrice && highPrice !== 'null'"
        :class="type == 'big' ? 'priceSmall white' : 'priceSmall'"
        >{{ dealHighPrice[1] }}</span
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "price",
  props: {
    type: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    price: {
      type: [String, Number],
      default: 0.01
    },
    highPrice: {
      type: [String, Number],
      default: 0
    },
    onlyOnePrice: {
      // 0多票品  1 但票品
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      fudou: require("@/assets/imgs/index/fudou.png")
    };
  },
  computed: {
    ...mapState({
      unionInfo: "unionInfo"
    }),
    dealPrice: function() {
      let price = this.unionInfo.scale
        ? this.unionInfo.scale *
          Number(this.price && this.price !== "null" ? this.price : 0.01)
        : this.price && this.price !== "null"
        ? this.price
        : 0.01;
      if (/\d/.test(price) && /\./.test(price)) {
        price = price.toString().split(".");
      } else {
        price = [`${price}`, "00"];
      }
      return price;
    },
    dealHighPrice: function() {
      let priceWrap = [];
      if (this.highPrice && this.highPrice !== "null") {
        let price = this.unionInfo.scale
          ? this.unionInfo.scale * Number(this.highPrice)
          : this.highPrice;
        if (/\d/.test(price) && /\./.test(price)) {
          priceWrap = price.toString().split(".");
        } else {
          priceWrap = [`${price}`, "00"];
        }
      }
      return priceWrap;
    }
  }
};
</script>
<style lang="less" scoped>
.price {
  height: 26px;
  line-height: 26px;
  .fudou {
    margin-top: 4px;
    width: 18px;
    height: 18px;
  }
  .priceBig {
    font-size: 22px;
    color: #f44545;
    font-weight: 500;
    margin-left: 3px;
  }
  .priceSmall {
    color: #f44545;
    font-size: 14px;
  }
  .white {
    color: white;
  }
  .start {
    color: #808a94;
    margin-left: 3px;
    font-size: 12px;
    position: relative;
    top: -1px;
  }
  .grey {
    color: #d5d8db;
  }
}
.small {
  height: 19px;
  line-height: 19px;
  .fudou {
    margin-top: 1px;
    width: 18px;
    height: 18px;
  }
  .priceBig {
    font-size: 22px;
    color: #f44545;
    font-weight: 500;
    margin-left: 3px;
  }
  .priceSmall {
    color: #f44545;
    font-size: 14px;
  }
  .white {
    color: white;
  }
  .start {
    color: #808a94;
    margin-left: 3px;
    font-size: 12px;
    position: relative;
    top: -1px;
  }
  .grey {
    color: #d5d8db;
  }
}
</style>
